import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ImmoTask } from 'src/app/model/immo-task/immo-task';
import { SubProject } from 'src/app/model/project/sub-project';
import { Tour } from 'src/app/model/tour/tour';
import { User } from 'src/app/model/user';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _get } from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineStorageReadControllerRequestService {
  private readonly get: <T>(
    path: string,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializeTour = (res) => res as Tour;
  private readonly deserializeSubProject = (res) => res as SubProject;
  private readonly deserializeTourForProjectResult = (res) =>
    res as TourForProjectResult;
  private readonly deserializeImmoTask = (res) => res as ImmoTask;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.get = _get('/tourInstaller', requestServices);
  }

  public offlineStorageReadTour(dateString: string): Promise<Tour> {
    return this.get(
      `/offlineStorageRead/${dateString}`,
      this.deserializeTour
    ).toPromise();
  }

  public offlineStorageSubProject(subProjectId: number): Promise<SubProject> {
    return this.get(
      `/offlineStorageReadSubProject/${subProjectId}`,
      this.deserializeSubProject
    ).toPromise();
  }

  public offlineStorageReadTourForProject(
    projectId: number
  ): Promise<TourForProjectResult> {
    return this.get(
      `/offlineStorageReadTourForProject/${projectId}`,
      this.deserializeTourForProjectResult
    ).toPromise();
  }

  public offlineStorageImmoTask(immoTaskId: number): Promise<ImmoTask> {
    return this.get(
      `/offlineStorageReadImmoTask/${immoTaskId}`,
      this.deserializeImmoTask
    ).toPromise();
  }
}

export interface TourForProjectResult {
  tour: Tour;
  subProjectInOtherTour: SubProjectInOtherTour;
  subProjectId: number;
}

interface SubProjectInOtherTour {
  subProject: SubProject;
  tourDate: Date;
  placerUser: User;
}
